/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs */

const en_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source map`)
};

const ar_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة المصادر`)
};

const bn_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উৎস মানচিত্র`)
};

const de_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellenkarte`)
};

const es_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de fuentes`)
};

const fr_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte des sources`)
};

const pt_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa de fontes`)
};

const zh_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源地图`)
};

const tr_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaynak haritası`)
};

const ru_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта источников`)
};

const pl_svc_rag_knowledge_assistants_scope_output5 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa źródeł`)
};

/**
* | output |
* | --- |
* | "Source map" |
*
* @param {Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_scope_output5 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_scope_output5(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_scope_output5(inputs)
	return en_svc_rag_knowledge_assistants_scope_output5(inputs)
});
export { svc_rag_knowledge_assistants_scope_output5 as "svc_rag-knowledge-assistants_SCOPE_output" }